module.exports = __webpack_public_path__ + "static/media/lab.1dd1d3d0.svg";